module.exports = __webpack_public_path__ + "static/media/demo2.74a874fe.png";